import React from 'react';
import { ContentComponentProps } from '../../../utils/pageBuilder/types';

export function PageBuilderText({
  children,
  htmlTag,
  contentType,
  className,
  'data-pb-style': styleId
}: ContentComponentProps) {
  const HtmlTag = htmlTag as React.ElementType;
  const classes = [contentType, className as string | undefined]
    .filter(Boolean)
    .join(' ');

  return (
    <HtmlTag className={classes} data-pb-style={styleId as string | undefined}>
      {children}
    </HtmlTag>
  );
}
